import React, { Component } from "react";
import Paper from "material-ui-next/Paper";
import { DataTable, IconButton, Loadable } from "components/support";

class DataTableView extends Component {
  config = () => {
    const { presenter } = this.props;

    return {
      identifier: "id",
      columns: [
        {
          accessor: "uuid",
          show: false
        },
        {
          acessor: "company_uuid",
          show: false
        },
        {
          accessor: "name",
          Header: "Nome"
        },
        {
          accessor: "email",
          Header: "E-mail"
        },
        {
          accessor: "identification",
          Header: "Identificação",
          align: "center",
          Cell: props => {
            const { identification } = props.original;

            if (identification) {
              if (identification.length === 11) {
                const query = identification.match(
                  /(\d{3})(\d{3})(\d{3})(\d{2})/
                );

                if (query) {
                  return `${query[1]}.${query[2]}.${query[3]}-${query[4]}`;
                }
              } else if (identification.length === 14) {
                const query = identification.match(
                  /(\d{2}?)(\d{3})(\d{3})(\d{4})(\d{2})/
                );

                if (query) {
                  return `${query[1]}.${query[2]}.${query[3]}/${query[4]}-${
                    query[5]
                  }`;
                }
              }
            }

            return identification;
          }
        },
        {
          accessor: "phone",
          Header: "Telefone",
          align: "center",
          Cell: props => {
            const { phone } = props.original;

            if (phone) {
              const query = phone.match(/(\d{2}?)(\d{5}|\d{4})(\d{4})/);

              if (query) {
                return `(${query[1]}) ${query[2]}-${query[3]}`;
              }
            }

            return phone;
          }
        },
        {
          id: "birth_date",
          accessor: "raw_birth_date",
          Header: "Data de Nasc.",
          type: "date",
          align: "center"
        },
        {
          id: "actions",
          Header: "Ações",
          align: "right",
          sortable: false,
          filterable: false,
          Cell: props => (
            <div>
              <IconButton
                mini
                icon="search"
                onClick={() => presenter.onViewCustomer(props.row._original)}
              />
              <IconButton
                mini
                icon="mode_edit"
                onClick={() => presenter.onEditCustomer(props.row._original)}
              />
              <IconButton
                mini
                icon="delete"
                onClick={() => presenter.onRequestDelete(props.row._original)}
              />
            </div>
          )
        }
      ]
    };
  };

  componentWillReceiveProps(nextProps) {
    if (nextProps.filters !== this.props.viewModel.filters) {
      this.props.presenter.onFilterChange(nextProps.filters);
    }
  }

  render() {
    const { presenter, viewModel } = this.props;
    const { content, pagination, loading, order } = viewModel;

    return (
      <div>
        <h3 style={{ textAlign: "right", padding: 10, margin: 0 }}>
          {pagination.total} cliente(s) encontrado(s).
        </h3>
        <Paper elevation={1} className="user__content">
          <Loadable loading={loading}>
            <DataTable
              manual
              filterable={false}
              resultSet={content}
              total={pagination.total}
              perPage={pagination.perPage}
              page={pagination.currentPage}
              config={this.config()}
              onChange={({ field, value }) =>
                presenter.onOrderChange(field, value)
              }
              orderField={order.field}
              orderDirection={order.direction}
              onPageChange={page => presenter.onPageChange(page + 1)}
            />
          </Loadable>
        </Paper>
      </div>
    );
  }
}

export default DataTableView;



// WEBPACK FOOTER //
// ./src/components/app/registration/customer/data-table/view.jsx